import { apiClient } from "@/api";
import type { ApiResponse, PaginatedData } from "@/types";
import type { Agent } from "@/types/agent";
import type { AxiosRequestConfig } from "axios";

export async function getAgents(
  page: number = 1,
  page_size: number = 10,
  config?: AxiosRequestConfig,
): Promise<PaginatedData<Agent>> {
  try {
    const { data } = await apiClient.get<ApiResponse<PaginatedData<Agent>>>(
      "/agents/",
      { ...config, params: { page, page_size } },
    );
    return data.data!;
  } catch {
    return { items: [], total: 0, page, page_size };
  }
}
export async function deleteAgent(agentId: string, config?: AxiosRequestConfig): Promise<void> {
  await apiClient.delete(`/agents/${agentId}`, config);
}

export interface CreateAgentPayload {
  name: string;
  provider?: string | null;
  short_description?: string | null;
  solution?: string | null;
  categories?: string[];
  application_area?: string | null;
  main_category?: string | null;
}

export async function createAgent(
  payload: CreateAgentPayload,
  draft: boolean = false,
  config?: AxiosRequestConfig,
): Promise<Agent> {
  const { data } = await apiClient.post<ApiResponse<Agent>>(
    "/agents/",
    payload,
    {
      ...config,
      params: { draft },
    },
  );
  return data.data!;
}

export async function getAgent(agentId: string, config?: AxiosRequestConfig): Promise<Agent> {
  const { data } = await apiClient.get<ApiResponse<Agent>>(
    `/agents/${agentId}`,
    config,
  );
  return data.data!;
}

export async function updateAgent(
  agentId: string,
  payload: CreateAgentPayload,
  draft: boolean = false,
  config?: AxiosRequestConfig,
): Promise<Agent> {
  const { data } = await apiClient.put<ApiResponse<Agent>>(
    `/agents/${agentId}`,
    payload,
    {
      ...config,
      params: { draft },
    },
  );
  return data.data!;
}
